/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);

const microNote = Vue.resource('micro_notes{/id}', {}, {}, { emulateJSON: true }); // emulateJSON so that the pdf file gets passed correctly

export default microNote;


// WEBPACK FOOTER //
// ./src/resources/microNote.js